// extracted by mini-css-extract-plugin
export default {"stepper":"Stepper_stepper__AR2xQ","box":"Stepper_box__8AmKK","button":"Stepper_button__Au7Qw","input":"Stepper_input__hbNVe"};